/* eslint-disable no-param-reassign */
<template>
  <b-overlay
    :show="loader.formulario"
    opacity="0.50"
    rounded="sm"
  >
    <div>
      <!-- Filters -->
      <filters
        v-show="!errorContent.filters"
        :status-filter.sync="configRequest.tiposolicitante"
        :status-options="tipoSolicitante"
        :loader="loader.filters"
      />
      <!-- Table Container Card -->
      <b-card
        v-show="!errorContent.table"
        no-body
        class="mb-0"
      >
        <!-- Datos cargados -->
        <b-card-header class="pb-0">
          <b-card-title />
          <b-card-text class="font-small-2 mr-25 mb-0">
            Datos cargados <b>{{ updatedAt }}</b>
          </b-card-text>
        </b-card-header>
        <!-- Table Top -->
        <div class="m-2">
          <b-row>
            <!-- Cantidad de elementos por página -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <span>Mostrar</span>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
            </b-col>
            <!-- Buscador -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon
                      :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                      :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                      @click="searchQuery != '' ? searchQuery = '' : ''"
                    />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="searchQuery"
                    placeholder="Buscar"
                  />
                </b-input-group>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-form class="mt-1">
          <b-overlay
            rounded="sm"
            :show="isBusyTable"
            opacity="0"
          >
            <b-table
              id="tabla_solicitudes"
              ref="refDataListTable"
              primary-key="indice"
              class="position-relative mitabla"
              empty-text="No se encontraron resultados"
              responsive
              show-empty
              hover
              striped
              :items="fetchData"
              :fields="tableColumns"
              :sort-desc.sync="isSortDirDesc"
              :sort-by.sync="sortBy"
              @row-clicked="clickenrow"
            >
              <!-- Column: calif -->
              <template #cell(solicita)="data">
                <p class="text-primary">
                  <b>{{ data.item.solicita }}</b>
                </p><hr>
                <small>Fecha de solicitud</small>
                <p><b>{{ timestampToDate( data.item.fecha_sol) }}</b></p>
                <hr>
                <small>Argumento</small>
                <p><b>"{{ data.item.argumento }}"</b></p>
                <hr>
                <small>Calificación original</small>
                <p><b>{{ data.item.calif_orig }}</b></p>
              </template>
              <template #cell(calif)="data">
                <small class="text-primary"><b>Calificación oficial</b></small>
                <p class="text-primary m-0">
                  <b>{{ data.item.calif }}</b>
                </p><hr class="m-0">
                <small>Evaluación por el profesor</small>
                <p><b>{{ data.item.calif_profesor }}</b></p>
                <p>"{{ data.item.observacion_profesor }}"</p>
                <hr class="m-0">
                <small>Evualuación por moodle</small>
                <p><b>{{ data.item.calif_moodle }}</b></p>
                <hr class="m-0">
                <small>Faltas</small>
                <p><b>{{ data.item.faltas }}</b></p>
              </template>
              <!-- Column: curso -->
              <template #cell(curso)="data">

                <h5>
                  <small>Alumno:</small>  {{ data.item.nombre_alumno }}
                </h5>
                <p>
                  <small>Matrícula:</small> <b class="text-primary">{{ data.item.matricula }}</b>
                </p>
                <p class="m-0">
                  <small>Email: {{ data.item.email }}</small>
                </p>
                <p>
                  <small>Teléfono: {{ data.item.telefono1 }}</small>
                </p>
                <hr>
                <h5 class="text-primary">
                  {{ data.item.nombre }} |  {{ data.item.clave }}
                </h5>
                <p class="m-0">
                  <small>Agenda:</small> <b>{{ data.item.periodo_agenda }}</b>
                </p>
                <p class="m-0">
                  <small><b>
                    Estado: {{ data.item.status }}
                  </b></small>
                </p>
                <p class="m-0"><small>
                  modalidad: {{ data.item.modalidad }}
                </small>
                </p>
                <p>
                  <small>
                    N° parciales: {{ data.item.num_parciales }}
                  </small>
                </p>
                <p>
                  <small>Plan de estudios: <b>{{ data.item.plan_estudios }}</b>
                  </small></p>
              </template>
              <template #cell(asignar)="data">
                <!-- Calificacion comite -->
                <validation-observer
                  :ref="`formcalicomite${data.index}`"
                >
                  <b-col
                    cols="12"
                  >  <b-form-checkbox
                       v-model="data.item.resolucion"
                       class="mb-1"
                       :class="data.item.resolucion == 1 ? 'rechazada' : 'aceptada'"
                       unchecked-value="0"
                       value="1"
                       switch
                       @change="chanceCalif(data.item)"
                     >
                       Esta Solicitud Será
                       <span>{{ data.item.resolucion == 1 ? 'Rechazada' : 'Aceptada' }}</span>
                     </b-form-checkbox>
                    <b-form-group
                      label="Calificación por el CHyJ"
                      label-for="calificación"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="calificación"
                        rules="required|between:0,100"
                      >
                        <b-form-input
                          v-model="data.item.calicomitehonor"
                          :state="errors.length > 0 ? false:null"
                          placeholder="Calificación"
                          autocomplete="off"
                          type="number"
                          :disabled="data.item.deshabilita"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                      label="Observaciones"
                      label-for="justificación"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="justificación"
                        rules="required|max:200|min:10"
                      >
                        <b-form-textarea
                          v-model="data.item.juscomitehonor"
                          placeholder="Observaciones"
                          :state="errors.length > 0 ? false:null"
                          autocomplete="off"
                          :disabled="data.item.deshabilita2"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group>
                      <hr>
                      <b-row>
                        <b-col>
                          <b-button
                            size="lg"
                            class="btn-icon rounded-circle"
                            :variant="returnIconVariant(data.item)"
                            @click="clickEditar(data.item)"
                          >
                            <feather-icon
                              :icon="returnIcon(data.item)"
                              class="cursor-pointer btn-icon rounded-circle"
                            />
                          </b-button>
                        </b-col>
                        <b-col>
                          <b-button
                            size="lg"
                            class="btn-icon rounded-circle"
                            :variant="returnIconVariant2(data.item)"
                            :disabled="returndisabled2(data.item)"
                            @click="clickGuardar(data.item)"
                          >
                            <feather-icon
                              :icon="returnIcon2(data.item)"
                              class="cursor-pointer btn-icon rounded-circle"
                            />
                          </b-button>
                        </b-col>
                        <small class="mt-1">Desbloquea para editar y bloquea para habilitar el guardado</small>
                        <small class="mt-1">Para guardar presiona el ícono verde de guardar</small>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </validation-observer>
              </template>
              <!-- row: actividades -->
              <template #row-details="row">
                <hr>
                <b class="text-primary">Responsables:</b>
                <div
                  v-for="profesor in row.item.profesores"
                  :key="profesor.email"
                > <b class="text-primary">{{ profesor.rol }}:</b> {{ profesor.nombre }}
                  <p>
                    <small><b>Email: </b>{{ profesor.email }}</small>
                    <small><b> Telefono: </b>{{ profesor.telefono1 }}</small></p>
                </div>
                <br>
                <b-table
                  striped
                  responsive
                  :items="row.item.actividades"
                  :fields="tableColumnsActividades"
                  :tbody-tr-class="rowClass"
                  primary-key="actividad"
                  show-empty
                  small
                  class="position-relative mitabla2"
                  empty-text="No se encontraron resultados"
                >
                  <template #cell(itemname)="data">
                    {{ data.value }}
                    <p
                      v-if="data.item.cmid === undefined && data.item.weightformatted != undefined"
                      class="m-0"
                    >
                      *Promedio con Ponderación
                    </p>
                    <p
                      v-if="data.item.cmid === undefined && data.item.weightformatted === undefined"
                      class="m-0"
                    >
                      TOTAL DEL CURSO
                    </p>

                  </template>
                  <template #cell(grademax)="data">
                    <small>Máx: {{ data.value }}</small>
                    <p class="m-0"><small>
                      Min: {{ data.item.grademin }}</small>
                    </p>
                  </template>
                  <template #cell(graderaw)="data">
                    {{ data.value }}
                  </template>
                  <template #cell(weightformatted)="data">
                    {{ data.value }}
                  </template>
                  <template #cell(gradedatesubmitted)="data">
                    <p
                      v-if=" data.item.gradedatesubmitted != null"
                      class="m-0"
                    >
                      <small>{{ timestampToDate( data.value, 'L' ) }}</small>
                      <small> | {{ timestampToDate( data.value, 'LT' ) }}</small>
                    </p>
                  </template>
                  <template #cell(gradedategraded)="data">
                    <p
                      v-if=" data.item.gradedategraded != null"
                      class="m-0"
                    >
                      <small>{{ timestampToDate( data.value, 'L' ) }}</small>
                      <small> | {{ timestampToDate( data.value, 'LT' ) }}</small>
                    </p>
                  </template>
                </b-table>
              </template>
            </b-table>
          </b-overlay>
          <!-- Table's footer & pagination -->
          <div class="mx-2 mb-2">
            <b-row>
              <!-- Leyenda de cuantos elementos se muestran -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItems"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BCardHeader,
  BCardText,
  BCardTitle,
  BInputGroup,
  BInputGroupPrepend,
  BOverlay,
  BButton,
  BForm,
  BFormGroup,
  BFormTextarea,
  BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, onMounted, watch } from '@vue/composition-api'
import {
  lastUpdate,
  timestampToDate,
  nombreModalidad,
  avatarText,
} from '@core/utils/filter'
import store from '@/store'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, between, max, min,
} from '@validations'
import { configTableComite, useComiteCatalogos } from '@/views/campus/ComiteHonor/useComiteHonor'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Filters from './components/Filters.vue'

export default {
  components: {
    Filters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BCardHeader,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupPrepend,
    BPagination,
    vSelect,
    BOverlay,
    BButton,
    BForm,
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
  },
  data() {
    return {
      timestampToDate,
      loader: {
        formulario: false,
      },
    }
  },
  setup() {
    const updatedAt = ref(lastUpdate())
    const loader = ref({ filters: false })
    const errorContent = ref({ filters: false, table: false })
    const { tableColumns, configRequest } = configTableComite()
    const { tipoSolicitante } = useComiteCatalogos()
    const tableColumnsActividades = [
      { key: 'itemname', label: 'Actividad', sortable: false },
      { key: 'weightformatted', label: 'Ponderación', sortable: false },
      { key: 'graderaw', label: 'Calificación', sortable: false },
      { key: 'grademax', label: 'Rango', sortable: false },
      { key: 'gradedatesubmitted', label: 'Persona', sortable: false },
      { key: 'gradedategraded', label: 'Sistema', sortable: false },
    ]
    const {
      fetchData, refetchData, refDataListTable,
      dataMeta,
      dynamicParamRequest,
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc, dataAux,
      isBusyTable,
      errorRequest,
    } = useFillDataTable()
    isSortDirDesc.value = false

    const USER_APP_STORE_MODULE_NAME = 'app-user'
    const actividadesMoodle = ref(null)
    //* On mounted
    onMounted(() => {
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content
    watch(configRequest.value, () => { refetchData() }) //* Any change in config params (filters), refetch table data
    watch(dataAux, () => {
      dataAux.value.forEach((element, index) => {
        if (dataAux.value[index].deshabilita === undefined) {
          dataAux.value[index].deshabilita = true
          dataAux.value[index].deshabilita2 = true
          dataAux.value[index].indice = index
          dataAux.value[index].juscomitehonor = null
          dataAux.value[index].calicomitehonor = null
          dataAux.value[index].resolucion = 0
        }
      })
    })

    return {
      between,
      required,
      max,
      min,
      fetchData,
      dataAux,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      // Filter
      lastUpdate,
      updatedAt,
      timestampToDate,
      nombreModalidad,
      avatarText,
      // Filter's option
      tipoSolicitante,
      // Extra Filters
      configRequest,
      // Loader
      loader,
      isBusyTable,
      // Error
      errorContent,
      actividadesMoodle,
      tableColumnsActividades,
    }
  },
  methods: {
    validationForm(dato) {
      this.$refs[`formcalicomite${dato.indice}`].validate().then(success => {
        if (success) {
          this.submitForm(dato)
        }
      })
    },
    chanceCalif(dato) {
      this.dataAux[dato.indice].resolucion = dato.resolucion === '1' ? 1 : 0
      if (this.dataAux[dato.indice].resolucion === 1) {
        this.dataAux[dato.indice].calicomitehonor = dato.calif_orig
        this.dataAux[dato.indice].deshabilita2 = false
        this.dataAux[dato.indice].deshabilita = true
      } else {
        this.dataAux[dato.indice].calicomitehonor = ''
        this.dataAux[dato.indice].deshabilita2 = true
      }
      this.$refs.refDataListTable.refresh()
    },
    returndisabled2(dato) {
      return !!(dato.resolucion === 0 && (dato.juscomitehonor === null || dato.juscomitehonor === '' || dato.calicomitehonor === null || dato.calicomitehonor === '' || dato.deshabilita === false))
    },
    returnIconVariant2(dato) {
      return ((dato.juscomitehonor === null || dato.juscomitehonor === '' || dato.calicomitehonor === null || dato.calicomitehonor === '' || dato.deshabilita === false)) ? 'secondary' : 'success'
    },
    returnIcon2(dato) {
      return ((dato.juscomitehonor === null || dato.juscomitehonor === '' || dato.calicomitehonor === null || dato.calicomitehonor === '' || dato.deshabilita === false)) ? 'MinusIcon' : 'SaveIcon'
    },
    returnIcon(dato) {
      return dato.deshabilita2 === false ? 'UnlockIcon' : 'LockIcon'
    },
    returnIconVariant(dato) {
      return dato.deshabilita2 === false ? 'success' : 'secondary'
    },
    clickEditar(dato) {
      const i = dato.indice
      if (dato.deshabilita === true && dato.resolucion === 0) this.dataAux[i].deshabilita = false
      else this.dataAux[i].deshabilita = true
      if (dato.deshabilita2 === true) this.dataAux[i].deshabilita2 = false
      else this.dataAux[i].deshabilita2 = true
      this.$refs.refDataListTable.refresh()
    },
    clickGuardar(dato) {
      this.validationForm(dato)
    },
    submitForm(dato) {
      this.loader.formulario = true
      const resoluciones = dato.resolucion === 1 ? 0 : 1
      const enviardata = {
        calicomitehonor: dato.calicomitehonor,
        juscomitehonor: dato.juscomitehonor,
        id_solicitud: dato.id_solicitud,
        periodo: dato.periodo_agenda,
        resolucion: resoluciones,
      }
      this.$store.dispatch('comiteHonor/postSolicitud', { action: 5, datos: enviardata })
        .then(response => {
          if (response.status === 200) {
            const rowhide = document.getElementById(`tabla_solicitudes__row_${dato.indice}`)
            rowhide.style.display = 'none'
            this.registroExitoso()
          } else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error al realizar post`,
              variant: 'danger',
              solid: true,
            })
          }
          this.loader.formulario = false
        }, error => {
          this.loader.formulario = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 10000 })
        })
    },
    registroExitoso() {
      this.$swal({
        title: '<b>Operación exitosa</b>',
        html: '',
        icon: 'success',
        timer: 10000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    clickenrow(item, index) {
      if (this.dataAux[index].profesores === undefined) {
        this.$store.dispatch('comiteHonor/fetchProfesores', { id: this.dataAux[index].curso_id })
          .then(response => {
            this.dataAux[index].profesores = response
          })
          .catch()
      }
      // llamar el otro servicio
      if (this.dataAux[index].actividades === undefined) {
        this.$store.dispatch('comiteHonor/fetchCalificacionesMoodle', { id: item.mdl_id, usuariomdl: item.moodle_id })
          .then(response => {
            this.actividadesMoodle = response
            this.dataAux[index].actividades = this.actividadesMoodle
            // eslint-disable-next-line no-underscore-dangle
            this.$set(item, '_showDetails', !item._showDetails)
          })
          .catch(() => { this.actividadesMoodle = undefined })
      } else {
        // eslint-disable-next-line no-underscore-dangle
        this.$set(item, '_showDetails', !item._showDetails)
      }
    },
    rowClass(item, type) {
      const colorClass = 'table-success'
      const colorClass2 = 'table-danger'
      if (!item || type !== 'row') { return }
      // eslint-disable-next-line consistent-return
      if (item.cmid === undefined && item.weightformatted === undefined) { return colorClass2 }
      // eslint-disable-next-line consistent-return
      if (item.cmid === undefined) { return colorClass }
    },
  },
}
</script>
<style>
 .mitabla tbody td {
  border-color: #706f6f;
    border-top-style: solid;
    border-top-width: 25px;
 }.mitabla2 tbody td {
    border-style: none;
 }

 .aceptada .custom-control-label::before {
  background-color: #28a745 !important;
}

.rechazada .custom-control-label::before {
  background-color: #dc3545 !important;
}
</style>
